const myHeaders: HeadersInit = new Headers({
  "Access-Control-Allow-Origin": "*",
  "Content-Type": "application/json",
});

const myHeadersDefault = new Headers();

const fetchConfig: RequestInit = {
  method: "GET",
  headers: myHeadersDefault,
  mode: "cors",
  cache: "no-cache",
};

const TIME = new Date();

const PROD_ES =
  "https://master.hbr.quest/schedule_hbr";
const DEV_ES = "/db/schedule_hbr";

const PROD_EG =
  "https://master.hbr.quest/schedule_gl";
const DEV_EG = "/db/schedule_gl";

export interface Campaign {
  cp_id: number;
  stl_id: string;
  info_id: number;
  category: string;
  in_date: string;
  out_date: string;
  name: string;
  version: number;
  chara_list: number[];
}

export default {
  async getCampaignData(): Promise<Campaign[]> {
    return await fetch(
      `${process.env.NODE_ENV === "production" ? PROD_ES : DEV_ES
      }.json?${TIME.getTime()}`,
      fetchConfig
    ).then((response) => {
      return response.json();
    });
  },
  async getGlobalCampaignData(): Promise<Campaign[]> {
    return await fetch(
      `${process.env.NODE_ENV === "production" ? PROD_EG : DEV_EG
      }.json?${TIME.getTime()}`,
      fetchConfig
    ).then((response) => {
      return response.json();
    });
  },
};